// =====================================
//	確認視窗
//	@author: Alan
//	@time 2015 / 12 / 18
// =====================================

window.InifECApp.directive('dpiSupport', ['$rootScope', '$ngModal', '$timeout', function ($rootScope, $ngModal, $timeout) {

	var _dir = {};

	var controller = ['$scope', function($scope) {

        // ===============================
        //  開啟 modal
        // ===============================
        var openModal = function() {
        	// $ngModal.openModal('dpi-support-modal');
            $scope.isOpen = true;
        }

        // ===============================
        //  關閉 modal
        // ===============================
        var closeModal = function() {
        	// $ngModal.closeModal('dpi-support-modal');
            $scope.isOpen = false;
        }

        var init = function() {        

            $timeout(function() {
                if(window.mobilecheck()) {
                    openModal();
                }
            }, 500);
        }

        /*==========================
            Events
        ==========================*/            
        // window.

        /*==========================
            Members
        ==========================*/

        /*==========================
            Methods
        ==========================*/
        $scope.closeModal = closeModal;
        
        /*==========================
            init
        ==========================*/
        init();
        
	}]

	_dir.restrict = "E";
	_dir.scope = true;
	_dir.templateUrl = "partials/modal/dpi_support.html";
	_dir.controller = controller;

	return _dir;
}]);